'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import useScrollDirection from 'ui/src/hooks/useScrollDirection';

import useHeader from './hooks/useHeader';
import HeaderBGEnum from './HeaderBGEnum';

export type HeaderProps = {
  enableHeaderBehavior?: boolean;
  animatedHeader?: boolean;
};

export type HeaderContainerProps = HeaderProps & {
  children: React.ReactNode;
};

function HeaderContainer({ children, enableHeaderBehavior = false, animatedHeader = true }: HeaderContainerProps) {
  const { isMobileMenuOpen, hasScrolled, bgHeader } = useHeader();
  const { isScrollingDown } = useScrollDirection();

  return (
    <header
      className={twMerge(
        'mb-10 h-20',
        'z-40 text-sm',
        { 'sticky top-0 transform duration-300': enableHeaderBehavior || animatedHeader },
        bgHeader === HeaderBGEnum.Dark && 'bg-site-neutrals-25',
        bgHeader === HeaderBGEnum.Light && 'bg-site-neutrals-0',
        bgHeader === HeaderBGEnum.Transparent && (hasScrolled ? 'bg-site-neutrals-0' : 'bg-transparent'),
        {
          'pointer-events-none opacity-0': isScrollingDown && !isMobileMenuOpen && animatedHeader,
          'shadow-lg': hasScrolled && animatedHeader,
        },
      )}
    >
      <div className={twMerge('relative box-content flex h-full items-center justify-between px-8 xl:mx-auto')}>
        {children}
      </div>
    </header>
  );
}

export default HeaderContainer;
